var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BaseModalComponent } from "../../../views/modal/base_modal.component";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormControl } from "@angular/forms";
import { BaseFormGroup } from "../../../models/form";
import { SupportService } from "../support.service";
var FixWidgetsModalComponent = /** @class */ (function (_super) {
    __extends(FixWidgetsModalComponent, _super);
    function FixWidgetsModalComponent(activeModal, supportService) {
        var _this = _super.call(this, activeModal) || this;
        _this.activeModal = activeModal;
        _this.supportService = supportService;
        _this.action = 'check';
        _this.resultMessage = '';
        _this.resultClass = '';
        _this.form = new BaseFormGroup({
            action: new FormControl(_this.action)
        });
        return _this;
    }
    FixWidgetsModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.form.valueChanges.subscribe(function (_a) {
            var action = _a.action;
            _this.action = action;
        });
    };
    FixWidgetsModalComponent.prototype.ok = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, response, hasProblems, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        me.isLoading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, me.supportService.fixWidgets(me.siteId, me.action, 'Fix widgets').toPromise()];
                    case 2:
                        response = _a.sent();
                        me.isLoading = false;
                        hasProblems = false;
                        if (response.report) {
                            if (Array.isArray(response.report)) {
                                hasProblems = response.report.length > 0;
                            }
                            else if (typeof response.report === 'object') {
                                // Проверяем, есть ли ключи в объекте (не пустой ли {})
                                hasProblems = Object.keys(response.report).length > 0;
                            }
                            else {
                                hasProblems = !!response.report;
                            }
                        }
                        if (hasProblems) {
                            // Если report содержит данные, выводим его
                            if (Array.isArray(response.report)) {
                                me.resultMessage = JSON.stringify(response.report, null, 2);
                            }
                            else if (typeof response.report === 'object') {
                                me.resultMessage = JSON.stringify(response.report, null, 2);
                            }
                            else {
                                me.resultMessage = response.report.toString();
                            }
                            me.resultClass = 'alert-warning';
                        }
                        else {
                            // Если report пустой или отсутствует (включая {})
                            me.resultMessage = 'Проблем не обнаружено';
                            me.resultClass = 'alert-success';
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        me.isLoading = false;
                        me.resultMessage = 'Ошибка: ' + (error_1.message || 'Неизвестная ошибка');
                        me.resultClass = 'alert-danger';
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return FixWidgetsModalComponent;
}(BaseModalComponent));
export { FixWidgetsModalComponent };
